import styled from "styled-components";
export const HeaderContainer = styled.header`
  background-color: ${({ theme }) => theme.colors.background};
  width: 100%;
  padding-top: 8px;
  z-index: 100;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      height: 80px;
      cursor: pointer;
      padding-bottom: 8px;
    }
  }
  .content {
    display: flex;
    align-items: flex-end;
    position: relative;
    background: #3c3c3b;
    border-top: 2px solid ${({ theme }) => theme.colors.border};
    padding: 6px 0;
    nav {
      display: flex;
      justify-content: space-between;
      a {
        color: #fff;
      }
      .menu-icon {
        display: none;
      }
      .overlay {
        display: none;
      }
      .menu {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        li {
          margin-left: 30px;
          position: relative;
        }
      }
      .panel-link {
        cursor: pointer;
        color: #fff;
      }
    }
  }
  @media only screen and (max-width: 760px) {
    padding-bottom: 0;
    position: sticky;
    top: 0;
    .top {
      .logo {
        height: 48px;
      }
      .welcome {
        font-size: 13px;
      }
    }
    .content {
      justify-content: space-between;
      position: relative;
      flex-direction: row-reverse;
      align-items: center;
      nav {
        display: flex;
        justify-content: space-between;
        a {
          color: #000;
        }
        .menu-icon {
          display: block;
          font-size: 24px;
          color: #fff;
        }
        .overlay {
          display: block;
          position: fixed;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          top: 0;
          right: ${({ menuStatus }) => (menuStatus ? "0" : "-100%")};
          transition: 0.3s all;
          z-index: 99;
        }
        .menu {
          position: fixed;
          width: 75%;
          height: 100%;
          background: #fff;
          top: 0;
          z-index: 100;
          padding: 32px 8px;
          flex-direction: column;
          right: ${({ menuStatus }) => (menuStatus ? "0" : "-75%")};
          transition: 0.3s all;
          color: #000;
          li {
            margin-bottom: 16px;
            &:before {
              display: none;
            }
          }
        }
        .panel-link {
          left: auto;
          right: 36px;
          bottom: 4px;
          a {
            color: #fff;
          }
        }
      }
    }
  }
`;
